import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'spv2-code-receive',
  templateUrl: './code-receive.component.html',
  styleUrls: ['./code-receive.component.scss']
})
export class CodeReceiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
